import { forwardRef } from "react";

import Icon from "@/components/Icon";
import GoogleClassroomSVG from "./GoogleClassroomSVG.svg.jsx";

const GoogleClassroomIcon = forwardRef((props, ref) => {
  return (
    // Forces the `viewBox` attribute to be added to the markup
    <Icon
      {...props}
      SvgComponent={GoogleClassroomSVG}
      viewBox="0 0 100 79"
      ref={ref}
    />
  );
});

export default GoogleClassroomIcon;
